import React, {useRef, useState, useEffect } from 'react';
import { Row, Col, Card, Button, Form } from 'react-bootstrap';
import classNames from 'classnames';
import Flex from '../../common/Flex';
import {contactType, edit, listLicense} from '../../../lib/api/contact';

export function Edit({ initEntities, initContact, onClose, onSave }) {
  const [entities, setEntities] = useState(initEntities);
  const [contact, setContact] = useState(initContact);
  const [contType, setContType] = useState([]);
  const [errors, setErrors] = useState({
    name: false,
    phone_1: false
  });

  useEffect(() => {
    (async () => {
      console.log('entities',entities)
      const resContType = await contactType(entities.entities_type_id);
      setContType(resContType);
    })();
  }, []);


  const handelInput = e => {
    const { name, value } = e.target;
    setContact({ ...contact, [name]: value });
  };

  const handleSubmit = async event => {
    event.preventDefault();
    if (!validateForm(event)) return;

    const form = event.currentTarget;

    console.log('form',form);

    const _data = {
      contact_type_id: form.contact_type_id.value,
      name: form.name.value,
      phone_1: form.phone_1.value,
      phone_2: form.phone_2.value,
      phone_3: form.phone_3.value,
      email: form.email.value,
      descreption: form.descreption.value
    };

    const formData = new FormData(event.currentTarget);
    //formData.append('descreption', '');

    await edit(Object.fromEntries(formData.entries()), contact.contact_guid);

    //await edit(_data, contact.contact_guid);
    onSave();
    onClose();
  };

  const validateForm = event => {
    const form = event.currentTarget;
    const newErrors = {
      name: contType.length <= 1 ? false : !form.name.value.trim(),
      phone_1: !(Boolean(form.phone_1.value.trim()) || Boolean(form.phone_2.value.trim()) || Boolean(form.phone_3.value.trim()) || Boolean(form.email.value.trim())),
    };
    setErrors(newErrors);

    if (Object.values(newErrors).some(error => error)) {
      event.stopPropagation();
      return false;
    }
    return true;
  };

  return (
      <Card>
        <Card.Body className="bg-body-tertiary">
          <Form
              method="POST"
              encType="multipart/form-data"
              noValidate
              onSubmit={handleSubmit}
          >
            <Row className="mb-3" style={{ display: contType.length <= 1 ? 'none' : 'flex' }}>
              <Form.Group as={Col} md="12" controlId="contact_type_id">
                <Form.Label>Vrsta</Form.Label>
                <Form.Select name="contact_type_id" value={contact.contact_type_id || ''} onChange={handelInput} isInvalid={errors.contact_type_id}>
                  {contType.map(p => <option key={p.contact_type_id} value={p.contact_type_id}>{p.name}</option>)}
                </Form.Select>
                <Form.Control.Feedback type="invalid">Molimo unesite vrstu kontakta.</Form.Control.Feedback>
              </Form.Group>
            </Row>

            <Row className="mb-3" style={{ display: contType.length <= 1 ? 'none' : 'flex' }}>
              <Form.Group as={Col} md="12" controlId="name">
                <Form.Label>Naziv</Form.Label>
                <Form.Control required type="text" name="name" value={contact.name || ''} onChange={handelInput} isInvalid={errors.name} />
                <Form.Control.Feedback type="invalid">Molimo unesite ime.</Form.Control.Feedback>
              </Form.Group>
            </Row>
            <Row className="mb-3">
              <Form.Group as={Col} md="6" controlId="phone_1">
                <Form.Label>Telefon 1:</Form.Label>
                <Form.Control required type="text" name="phone_1"  value={contact.phone_1 || ''} onChange={handelInput}  isInvalid={errors.phone_1} />
                <Form.Control.Feedback type="invalid">Molimo unesite kontakt.</Form.Control.Feedback>
              </Form.Group>

              <Form.Group as={Col} md="6" controlId="phone_2">
                <Form.Label>Telefon 2:</Form.Label>
                <Form.Control required type="text" name="phone_2" value={contact.phone_2|| ''} onChange={handelInput} />
              </Form.Group>

            </Row>
            <Row className="mb-3">
              <Form.Group as={Col} md="6" controlId="phone_3">
                <Form.Label>Telefon 3:</Form.Label>
                <Form.Control required type="text" name="phone_3" value={contact.phone_3|| ''} onChange={handelInput}/>
              </Form.Group>
              <Form.Group as={Col} md="6" controlId="email">
                <Form.Label>email</Form.Label>
                <Form.Control required type="text" name="email" value={contact.email|| ''} onChange={handelInput} isInvalid={errors.email} />
                <Form.Control.Feedback type="invalid">Molimo unesite email.</Form.Control.Feedback>
              </Form.Group>
            </Row>
            <Row className="mb-3">
              <Form.Group className="mb-3" controlId="descreption">
                <Form.Label>Komentar</Form.Label>
                <Form.Control as="textarea" name="descreption" rows={3}  value={contact.descreption|| ''} onChange={handelInput}  />
              </Form.Group>
            </Row>

            <Button type="submit">Sačuvaj</Button>
          </Form>
        </Card.Body>
      </Card>
  );
}
